export const getEnv = (name: string) => {
  // @ts-ignore
  return window._env_[name] || process.env[name]
}
